import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { PayRun } from "./types";

export function usePayRuns() {
  return useQuery<PayRun[]>({
    queryKey: ["pay-runs"],
    queryFn: async () => {
      const res = await apiFetch("/api/v1/payroll/runs", {
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error("Could not load pay runs");
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    },
    refetchOnWindowFocus: false,
  });
}